import React from 'react';

const Container = ({ children }) => {
  return (
    <div className="px-[5%] lg:px-[120px]">
      {children}
    </div>
  );
};

export default Container;
